import { useState, useEffect } from 'react';
import { decodeBase64Value, handleUnexpectedException } from 'src/helpers/functions';
import { networkProvider } from 'src/utils/networkProvider';
import { smartContract } from 'src/utils/smartContract';

function useMinimumStaking() {
    const [minimumStaking, setMinimumStaking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMinimumStaking = async () => {
            try {
                const interaction = smartContract.methods.minimumStaking();
                const query = interaction.check().buildQuery();
                const queryResponse = await networkProvider.queryContract(query);
                const minStakingAmount = queryResponse.returnData[0] || 0;

                setMinimumStaking(decodeBase64Value(minStakingAmount));
            } catch (err) {
                handleUnexpectedException(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchMinimumStaking();
    }, []);

    return { minimumStaking, loading, error };
}

export default useMinimumStaking;
